<template>
  <section
    class="contacts"
    itemscope itemtype="http://schema.org/ContactPoint"
  >
    <h3 class="the-footer-heading">Контакты</h3>
    <p class="company-name">
      ЧПУП «<span itemprop="name">Ювелирная фирма «Стиль»</span>
    </p>
    <div
      class="contact-info-wrapper"
      itemprop="areaServed"
      itemscope itemtype="http://schema.org/Place"
    >
      <meta itemprop="name" content="Ювелирная фирма «Стиль»">
      <meta itemprop="telephone" content="+375 29 8888-099">
      <address
        class="contact-info"
        itemprop="address"
        itemscope itemtype="http://schema.org/PostalAddress"
      >
        <span itemprop="addressCountry">Беларусь</span>,
        г. <span itemprop="addressLocality">Брест</span>,
        ул. <span itemprop="streetAddress">Сябровская 51"А"</span>
      </address>
    </div>
    <ul class="phones-list">
      <li>
        <a href="tel:+375-29-8888-099">
          <span itemprop="telephone">+375 29 8888-099</span>
        </a> (мтс, viber)
      </li>
      <li>
        <a href="tel:+375-29-908-76-07">
          <span itemprop="telephone">+375 29 908-76-07</span>
        </a> (velcom)
      </li>
      <li>
        <a href="tel:+375-162-52-72-40">
          <span itemprop="faxNumber">+375 162 52-72-40</span>
        </a> (т/ф)
      </li>
    </ul>
  </section>
</template>

<script>
export default {
  name: 'Contacts',
  data () {
    return {}
  }
}
</script>

<style scoped lang="scss">
  .contact-info {
    font-style: normal;
    margin-bottom: 1em;
  }
  .company-name {
    line-height: normal;
    margin-bottom: 0;
  }
  .phones-list {
    margin: 0 auto;
    a { text-decoration: none; }
    & > li {
      display: block;
      margin: 0 0 0.5em 0;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/the-footer/Contacts.vue